import { render } from "./ControlButton.vue?vue&type=template&id=20e811d5&ts=true&lang=pug"
import script from "./ControlButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ControlButton.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__